import { Controller } from "@hotwired/stimulus"

const isCheckable = (element) => ["checkbox", "radio"].includes(element.type)

export default class extends Controller {
  static targets = ["input", "loadingIndicator", "resultsFrame"]

  applyFilter(e) {
    const target = e.currentTarget

    const attributeName = target.name.match(/\[(\w+)\]/)[1]
    let val = target.value

    if (isCheckable(target)) {
      val = +target.checked
    }

    if (val) {
      this.filterParams.set(attributeName, val)
    } else {
      this.filterParams.delete(attributeName)
    }

    this.submitFilters()
  }

  clearFilters() {
    this.inputTargets.forEach((input) => {
      if (isCheckable(input)) {
        input.checked = false
      } else {
        input.value = ""
      }

      input.dispatchEvent(new Event("input", { bubbles: true }))
    })
  }

  connect() {
    this.filterParams = new URLSearchParams(window.location.search)

    if (this.hasResultsFrameTarget) {
      this.resultsFrameTarget.addEventListener("turbo:before-fetch-request", (event) => {
        // This event fires when hovering over the frame's links. This prevents that
        if (event.target != this.resultsFrameTarget) {
          return
        }

        this.toggleLoading(true)
      })

      this.resultsFrameTarget.addEventListener("turbo:frame-load", (event) => {
        this.toggleLoading(false)
      })
    }
  }

  toggleLoading(isVisible) {
    if (!this.hasLoadingIndicatorTarget) {
      return
    }

    if (isVisible) {
      this.loadingIndicatorTarget.classList.remove("hidden")
    } else {
      this.loadingIndicatorTarget.classList.add("hidden")
    }
  }

  submitFilters() {
    if (!this.hasResultsFrameTarget) {
      return
    }

    const baseURL = window.location.href.split("?")[0]
    const url = `${baseURL}?${this.filterParams.toString()}`

    this.resultsFrameTarget.setAttribute("src", url)
  }
}
